<template>
  <div id="model-area">
    <a-modal
      v-model="visible"
      ok-text="确认"
      cancel-text="取消"
      @ok="hideModal"
    >
    </a-modal>
  </div>
</template>

<script>
export default {
  props: ["title", "content", "ok", "cancel"],
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    hideModal() {
      this.visible = false;
    },
    show() {
      let that = this;
      this.$confirm({
        title: that.title,
        content: that.content,
        okText: "确认",
        cancelText: "取消",
        onOk() {
          if (that.ok) {
            that.ok();
          }
          that.hideModal();
        },
        onCancel() {
          if (that.cancel) {
            that.cancel();
          }
          that.hideModal();
        },
      });
    },
  },
};
</script>

<style scoped>
</style>